const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const normalizeContentValues = values => {
  if (Array.isArray(values)) {
    return values
      .flatMap(value => {
        if (typeof value === 'string') {
          return value.split(',');
        }

        if (value?.id) {
          return [value.id];
        }

        return [];
      })
      .map(value => `${value}`.trim())
      .filter(Boolean);
  }

  if (typeof values === 'string') {
    return values
      .split(',')
      .map(value => value.trim())
      .filter(Boolean);
  }

  if (!values) {
    return [];
  }

  return [`${values}`.trim()].filter(Boolean);
};

const generateValues = item => {
  if (item.attribute_key === 'content') {
    return normalizeContentValues(item.values);
  }

  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }

  if (typeof item.values === 'object') {
    return [item.values.id];
  }

  if (!item.values) {
    return [];
  }

  return [item.values];
};

const generatePayload = data => {
  const filters = JSON.parse(JSON.stringify(data));
  const payload = filters.map(item => {
    item.values = generateValues(item);
    return item;
  });

  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
